// import * as module from "./module";

// module.test( module.message );

tables = document.querySelectorAll("#content table");
tables.forEach((ele) => {
	ele.outerHTML = "<div class='table--responsive'>" + ele.outerHTML + "</div>";
});
